import type { Data } from 'types/hashtag';

const LIMIT = 40;
const MOBILE_LIMIT = 4;
const FEED_LIMIT = 24;
const SEARCH_LIMIT = 30;
const SINGLE_VIEW_LIMIT = 60;
const NOFOLLOW_NOINDEX_LIMIT = 50;
const SINGLE_VIEW_SLIDERS_LIMIT = 10;
const SINGLE_VIEW_SIMILAR_LIMIT = 5;

const BEARER_TOKEN = 'Jj4wxb89Uysc8bgPe7r6';

const REQUEST_HEADERS = {
  CF_IP_COUNTRY: 'cf-ipcountry',
  COUNTRY_CODE: 'country-code',
  USER_AGENT: 'user-agent',
  DEVICE_ID: 'deviceId',
  PLATFORM: 'platform',
  MARKET: 'market',
};

const GTM_EXCLUDED_PATHS = ['/e/[id]'];

enum ActionTypes {
  fixed = 'fixed',
  crop = 'crop',
  min = 'min',
}

enum DIRECTIONS {
  NEXT = 'next',
  PREV = 'prev',
  LEFT = 'left',
  RIGHT = 'right',
}

const INITIAL_STATE: Data = {
  next_page: null,
  total: 0,
  data: [],
  page: 1,
};

const MASONRY_DATA_TEMPLATE = {
  metadata: { next_page: '' },
  response: [],
  status: null,
  total: 0,
};

enum SOCIAL_MEDIA_TYPE_ENUM {
  FACEBOOK,
  PINTEREST,
  TWITTER,
  LINKEDIN,
  TUMBLR,
}

const PAGE_QUERY_REGEX = /page=([^&]*)/;

export enum IMAGE_TYPES {
  'sticker' = 'sticker',
  'photo' = 'photo',
}
export const IMAGE_ROUTE_PREFIXES = ['sticker', 'image', 'gif'];

const HASHTAG_NO_INDEX_REGEX = /^([_\w\d]{2,51})$/;

enum MASONRY_IMAGE_SIZES {
  ExtraLarge = 1600,
  Large = 1250,
  Medium = 800,
  Small = 580,
}

const NotFound = { notFound: true };
const WEBSITE_SCHEMA_NOT_INCLUDED_PAGES = ['templates'];

const TEMPLATES_DEFAULT_CATEGORY = 'all';
const DEFAULT_IMAGE_QUALITY = 85;
const TEMPLATES_LIMIT = 30;

export {
  WEBSITE_SCHEMA_NOT_INCLUDED_PAGES,
  TEMPLATES_DEFAULT_CATEGORY,
  SINGLE_VIEW_SLIDERS_LIMIT,
  SINGLE_VIEW_SIMILAR_LIMIT,
  NOFOLLOW_NOINDEX_LIMIT,
  HASHTAG_NO_INDEX_REGEX,
  SOCIAL_MEDIA_TYPE_ENUM,
  MASONRY_DATA_TEMPLATE,
  DEFAULT_IMAGE_QUALITY,
  MASONRY_IMAGE_SIZES,
  GTM_EXCLUDED_PATHS,
  SINGLE_VIEW_LIMIT,
  PAGE_QUERY_REGEX,
  TEMPLATES_LIMIT,
  REQUEST_HEADERS,
  INITIAL_STATE,
  BEARER_TOKEN,
  MOBILE_LIMIT,
  SEARCH_LIMIT,
  ActionTypes,
  FEED_LIMIT,
  DIRECTIONS,
  NotFound,
  LIMIT,
};
